import { v4 as uuidv4 } from "uuid";
import { EVENTS } from "./event-list";
import { selectors, store } from "../user/redux/store";

const EVENT_ATTRIBUTE = "data-track-click";
const TRACKER_ENDPOINT = "/api/index.php?method=registerEvent";
const TRACK_ACTION = "register-event";

let lastEventValue: string | null = null;
let lastEventTime: number = 0;
const THROTTLE_DELAY = 3000;

// Track elements that already have listeners to prevent duplicates
const elementsWithListeners = new WeakSet();

const getLoggedOutUUID = () => {
    if (!localStorage.sessionUUIDsn) {
        const sessionUUIDsn = uuidv4();
        localStorage.setItem("sessionUUIDsn", sessionUUIDsn);
        return sessionUUIDsn;
    }
    return localStorage.sessionUUIDsn;
};

const getDeviceType = () => {
    const userAgent = navigator.userAgent;
    if (
        userAgent.match(
            /Android|BlackBerry|iPhone|iPod|Opera Mini|IEMobile|WPDesktop/i
        )
    ) {
        return "mobile";
    } else if (userAgent.match(/iPad/i) || userAgent.match(/Tablet/i)) {
        return "tablet";
    } else {
        return "desktop";
    }
};

export const trackClickEventHandler = (event: Event) => {
    const target = event.target as HTMLElement;

    // Find the element with data-track-click attribute (could be the target or its ancestor)
    const elementWithAttribute = target.closest(`[${EVENT_ATTRIBUTE}]`);

    if (!elementWithAttribute) {
        return;
    }

    const eventValue = elementWithAttribute.getAttribute(EVENT_ATTRIBUTE);
    trackClickEvent(eventValue as keyof typeof EVENTS);
};

const setupListeners = () => {
    const elementsToTrack = document.querySelectorAll(`[${EVENT_ATTRIBUTE}]`);

    elementsToTrack.forEach((element) => {
        // Only add listener if this element doesn't already have one
        if (!elementsWithListeners.has(element)) {
            element.addEventListener("click", trackClickEventHandler);
            elementsWithListeners.add(element);
        }
    });

    window.addEventListener("sg-tool-click", (e: Event) => {
        console.log("sg-tool-click", e);
        if ((e as CustomEvent).detail.value) {
            trackClickEvent((e as CustomEvent).detail.value);
        }
    });

    // other legacy events
    document.addEventListener("click_summarize_cta", () =>
        trackClickEvent("summarize-cta")
    );
};

export const trackClickEvent = (eventValue: string | null) => {
    if (!eventValue || !EVENTS[eventValue]) {
        return;
    }

    const currentTime = Date.now();
    if (
        eventValue === lastEventValue &&
        currentTime - lastEventTime < THROTTLE_DELAY
    ) {
        return;
    }

    const { uuid: user_id } = selectors.auth.credentials(store.getState().auth);

    const data = {
        action: TRACK_ACTION,
        event_type_id: EVENTS[eventValue],
        uuid: getLoggedOutUUID(),
        user_uuid: user_id,
        url: window.location.pathname + window.location.search,
        device: getDeviceType(),
        referer: document.referrer,
    };

    const payload = JSON.stringify(data);
    navigator.sendBeacon(TRACKER_ENDPOINT, payload);

    lastEventValue = eventValue;
    lastEventTime = currentTime;
};

if (document.readyState === "complete") setupListeners();
else document.addEventListener("DOMContentLoaded", setupListeners);

window.addEventListener("data-track-event-added", setupListeners);
